import { render, staticRenderFns } from "./FilesSettings.vue?vue&type=template&id=78d525c6&"
import script from "./FilesSettings.vue?vue&type=script&lang=js&"
export * from "./FilesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports